import {z} from 'zod';

export const CONTENT_LANGUAGE_CODES = ['fr', 'en', 'nl', 'de', 'el', 'ro', 'bg', 'pl'] as const;
export const ContentLanguageCodeSchema = z.enum(CONTENT_LANGUAGE_CODES);
export type ContentLanguageCode = z.infer<typeof ContentLanguageCodeSchema>;

export const CONTENT_LANGUAGE_LABELS: Record<ContentLanguageCode, string> = {
  fr: 'general.labels.languages.french',
  en: 'general.labels.languages.english',
  nl: 'general.labels.languages.dutch',
  de: 'general.labels.languages.german',
  el: 'general.labels.languages.greek',
  ro: 'general.labels.languages.romanian',
  bg: 'general.labels.languages.bulgarian',
  pl: 'general.labels.languages.polish',
};

export const TenantContentLanguagesResponseSchema = z.object({
  enabledLanguages: z.array(ContentLanguageCodeSchema),
});
export type TenantContentLanguagesResponse = z.infer<typeof TenantContentLanguagesResponseSchema>;

export const SetTenantContentLanguagesRequestSchema = z.object({
  languages: z.array(ContentLanguageCodeSchema),
});
export type SetTenantContentLanguagesRequest = z.infer<
  typeof SetTenantContentLanguagesRequestSchema
>;
